<app-alert></app-alert>
<div class="row ">
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
    <div class="col-sm-12 col-md-4 align-center">
        <legend> About Me</legend>
    </div>
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
</div>
<div class="row intro">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
        <b class="emphasize-text">Hello </b>and welcome to my page. My name is
        <b class="emphasize-text">Jenny Phan </b>and I am a half Korean and half caucasian chick.  During the day I am a Senior Software Engineer and I also have a love for beauty and health and a passion for dancing. I guess
        you came to this page because you wanted to know a little bit about me, so I will share my story below.
        <br>

    </div>
</div>

<div>
<div class="row two-column">
    <div class="col-sm-12 col-lg-6 pic-style ">
        <img
            src="/assets/img/me3_Fotor_smaller.jpg"
            class='img-fluid'
            alt="Jenny"
        >
    </div>
   

    <div class="col-sm-12 col-lg-5 text-justify text-add-line-height who-am-i">
        <h1>Who am I</h1>
        <br>
        My love for dancing started when I was just a small child. I always knew I wanted to dance and I would come home
        from school
        every day, turn on the music and dance my heart away. I never really had the opportunity as a child to take
        dance
        classes as I came from an under privileged family.
        <br>
        <br> In addition to dancing, as a small child I also had a love for computers. I wrote my first computer program
        using
        the Commodore 64. I also took many programming classes in high school and programming seemed to come fairly easy for me.
        Throughout
        my classes in high school I ended up helping many of the other students and was recommended by my teacher to
        take
        the advanced classes.
        <br>
        <br> When I went off to attend the University, like most others, I was not sure what I wanted to do. I knew I
        had a love
        for dancing and had a natural rhythm to music but I had no experience. Since programming seemed fairly easy to
        me,
        paid well and there was a demand for it, I decided to study Computer Science. I decided that once I graduated
        with
        my degree, that I would go crazy and take all the dance classes that I could and that is exactly what I did.

    </div>
</div>
</div>
<br>


<div class="row">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
        Besides dancing I also enjoy spending time with friends, traveling, reading, creating youTube kAsianBeauti videos and working out. 
        <br>
        <br> As far as my personality traits I would say I am a dedicated person who does not give up easily and will
        put in
        the time necessary to accomplish my goals/tasks. I am also very determined and not afraid of hard work.
    </div>
</div>
<br>

<div class="row">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
        You might be wondering why I chose the name of my site to be
        <b class="emphasize-text">k A s i a n B e a u t i</b>
        I originally chose this domain name because I am half Korean/Asian and have an interest in Korean beauty. I traveled to Korea a
        few years
        ago and was intrigued by the focus that the Koreans had on their skin. So I invested a lot of time into studying
        their products and had decided that maybe at some time in the future I would start selling the products and sharing the information that I have
        studied and learned. Thus
        I came up with the name kasian for Korean American Asian, since I am half Korean and American and added the word
        beauti at the end.
        <br>
        <br>I started working at a very young age. My mother was really good at finding my brothers and I work. I did
        pretty
        much did everything I could to make money. I went Christmas caroling, delivered newspapers and was a babysitter.
        If there was one thing I learned from my mother, it was the value of hard work. I believe you can be good at
        anything
        if you work hard at it. Coming from an under privileged family, I felt I never really fit in , but because of it
        I never felt I had to follow along with any crowd and I learned to be myself. I never really let other peoples
        opinions
        influence me unless it is really someone I admire. I feel that there is no such thing as failure and for every
        failure
        there is an opportunity to learn, you will always get something out of trying. I also feel the road to success
        is
        the same no matter what you do, it is no different whether you are trying to become the best dancer or design
        the
        best application. The same principals apply.
    </div>
</div>
<br>
<div class="row">
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
    <div class="col-sm-12 col-md-4 align-center">
        <legend>Work</legend>
    </div>
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
</div>
<div class="row">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
        I have been working in information technology for over 15 years and I currenlty work as a Senior Software
        Enginner. I design and develop software, research technology components and recommend solutions.
        My
        focus is primarily on solving complex technology dependent problems and looking at different ways to solve a
        problem,
        calculating the risks and providing the best solution. My latest interest has been working on emerging Web
        Technologies
        and desiging and building responsive single page appications that are easy to read, maintain and modify.
        <br>
        <br> I have a bachelor's degree in Computer Science from Wayne State Univeristy. I completed the Expert
        Engineer
        program for a firm that I worked for. This is a specific program which only 10% of technologists have completed
        the
        program. It is a technology leadership program which equips high performing technologists with the skills needed
        to solve complex technology driven business problems. I am an active particpant in many outside technology user
        groups
        and have been on the executive board for the Chicago Java Users Group and the Illinois Java Users Group. I enjoy
        learning new technologies and leading and mentoring others. I have been involved in many programs to help students and one 
        specifically where I 
        mentored collegiate students for a high school in Dallas.
    </div>
</div>